import { render, staticRenderFns } from "./CoproducerProducts.vue?vue&type=template&id=6017fc1c&scoped=true&"
import script from "./CoproducerProducts.vue?vue&type=script&lang=js&"
export * from "./CoproducerProducts.vue?vue&type=script&lang=js&"
import style0 from "./CoproducerProducts.vue?vue&type=style&index=0&id=6017fc1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6017fc1c",
  null
  
)

export default component.exports